import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlaneEngines, faLoader, faUserClock } from "@fortawesome/pro-duotone-svg-icons";
import { getCurrentBanks, getCurrentBankVacation } from '../../../actions/bankBalance';
import { IsEnglish } from '../../../utils/language';
import * as storage from '../../../utils/storage';
import { toDisplayDecimal } from '../../../utils';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper
    },
    titleCurrentBalances: {
        color: 'var(--color1)',
        display: 'flex',
        width: '100%',
        fontWeight: 'bold'
    },
    spanTitleBold: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        fontWeight: 'bold',
        height: '50px',
        placeItems: 'center'
    },
    spanTitle: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
    },
    spanSubTitle: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        color: '#b5b5b5',
        fontSize: '14px'
    },
    spanImage: {
        display: 'flex',
        width: '100%',
        padding: '10px',
        justifyContent: 'center',
    },
    divTypeBalance: {
        display: 'flex',
        overflowX: 'auto'
    },
    divVacation: {
        float: 'left',
        display: 'table',
        padding: '10px',
        minWidth: '190px'
    },
    divBanks: {
        padding: '10px',
        minWidth: '190px'
    },
    separator: {
        borderLeft: '1px solid #cecece',
        float: 'left',
        height: '175px',
        marginTop: '10px'
    }
}));

function BalanceRequest(props) {
    const classes = useStyles();

    const [dataBanks, setDataBanks] = useState(null);
    const [dataVacation, setDataVacation] = useState(null);

    const isDisplayBankVacation = storage.getIsDisplayBankVacation();
    const isDisplayBankOthers = storage.getIsDisplayBankOthers();
    const showSectionCurrentBalance = isDisplayBankVacation || isDisplayBankOthers;

    useEffect(() => {
        loadPage();
    }, []);

    useEffect(() => {
        if (props.isReload) {
            setDataBanks(null);
            setDataVacation(null);
            loadPage();
        }
    }, [props.isReload]);

    const loadPage = () => {
        loadCurrentBanks();
        loadBankVacation();
    }

    const loadCurrentBanks = async () => {
        let response = await getCurrentBanks();

        response = JSON.parse(response);

        if (response.length > 0) {
            setDataBanks(response);
        }
    }

    const loadBankVacation = async () => {
        let response = await getCurrentBankVacation();

        response = JSON.parse(response);

        setDataVacation(response);
    }

    const SectionBankVacation = () => {
        return (
            isDisplayBankVacation && <div className={classes.divVacation}>
                <span className={classes.spanTitleBold}>{i18next.t('request:requestType.vacation')}</span>
                <span className={classes.spanImage}>
                    {dataVacation && <FontAwesomeIcon icon={faPlaneEngines} style={{ fontSize: "55px", color: '#5c7fb9' }} />}
                    {!dataVacation && <FontAwesomeIcon icon={faLoader} style={{ fontSize: "55px" }} spin />}
                </span>
                {dataVacation &&
                    <>
                        <span className={classes.spanTitle}>{`${toDisplayDecimal(dataVacation.unitUsed)} ${i18next.t('request:title.unitUsed')}`}</span>
                        <span className={classes.spanSubTitle}>{`${toDisplayDecimal(dataVacation.provisionalUnitsBalance)} ${i18next.t('bankBalance:form.provisionalUnitBalance')}`}</span>
                    </>
                }
            </div>
        )
    }

    const SectionBankOthers = () => {
        return (
            isDisplayBankOthers && dataBanks != null && dataBanks.map((obj, index) =>
                <div key={index}>
                    {(isDisplayBankVacation || (!isDisplayBankVacation && index > 0)) &&
                        <div className={classes.separator}>&nbsp;</div>
                    }
                    <div className={classes.divBanks}>
                        <span className={classes.spanTitleBold}>{IsEnglish() ? obj.bankEn : obj.bankFr}</span>
                        <span className={classes.spanImage}>
                            {dataBanks && <FontAwesomeIcon icon={faUserClock} style={{ fontSize: "55px", color: '#5c7fb9' }} />}
                            {!dataBanks && <FontAwesomeIcon icon={faLoader} style={{ fontSize: "55px" }} spin />}
                        </span>
                        {dataBanks && <span className={classes.spanTitle}>{`${toDisplayDecimal(obj.takenUnit)} ${i18next.t('request:title.unitUsed')}`}</span>}
                        <span className={classes.spanSubTitle}>{`${toDisplayDecimal(obj.provisionalUnitBalance)} ${i18next.t('bankBalance:form.provisionalUnitBalance')}`}</span>
                    </div>
                </div>
            )
        )
    }

    return (
        showSectionCurrentBalance && (<div data-id="headerBalanceRequest" className={classes.root}>
            <span className={classes.titleCurrentBalances}>{i18next.t('request:title.currentBalances')}</span>
            <div className={classes.divTypeBalance}>
                {<SectionBankVacation />}
                {<SectionBankOthers />}
            </div>
        </div>)
    );
}

export default withNamespaces(['request', 'bankBalance'], { wait: true })(BalanceRequest);